<template>
    <v-container fluid>
      <div class="esign-backbar">
        <v-btn text class="esign-back-btn" @click="back()">
          <v-icon left>mdi-arrow-left</v-icon> Kembali
        </v-btn>
      </div>
      <div class="mb-5">
        <material-card
          color="primary"
          :title="formData.nama ? 'Akses Menu — ' + formData.nama : 'Akses Menu per Peran'"
          :text="formData.kode_peran ? 'Kode peran ' + formData.kode_peran : ''"
          class="card-wrapper"
        >
          <template v-if="isAdmin" v-slot:head-actions>
            <v-btn depressed color="primary" @click="save()">Simpan perubahan</v-btn>
          </template>


          <v-alert v-if="errorMessageData" type="error" text dense border="left" class="mb-3">
            {{ errorMessage }}
          </v-alert>

          <p v-if="isAdmin" class="mp-help">
            Klik menu untuk memilihnya, lalu gunakan tombol di tengah untuk memindahkannya.
          </p>

          <div class="mp" :class="{ 'mp--readonly': !isAdmin }">
            <!-- Menu yang belum bisa diakses -->
            <section class="mp-panel">
              <header class="mp-panel__head">
                <h3 class="mp-panel__title">Menu tersedia <span class="mp-count">{{ displayAvailable.length }}</span></h3>
                <v-text-field
                  v-model="searchAvailable"
                  placeholder="Cari menu"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details
                  class="mp-search"
                />
              </header>
              <ul class="mp-list">
                <li v-for="item in filteredAvailable" :key="'a-' + item.id">
                  <component
                    :is="isAdmin ? 'button' : 'div'"
                    :type="isAdmin ? 'button' : null"
                    class="mp-row"
                    :class="{ 'is-picked': isPicked(item) }"
                    :aria-pressed="isAdmin ? String(isPicked(item)) : null"
                    @click="isAdmin && toggleItem(item)"
                  >
                    <v-icon v-if="isAdmin" small class="mp-row__check">{{ isPicked(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                    <span class="mp-row__text">
                      <span class="mp-row__name">{{ item.nama }}</span>
                      <span v-if="hasRoute(item)" class="mp-row__route">{{ item.route }}</span>
                    </span>
                  </component>
                </li>
              </ul>
              <p v-if="filteredAvailable.length === 0" class="mp-empty">
                {{ displayAvailable.length === 0 ? 'Semua menu sudah bisa diakses peran ini' : 'Menu tidak ditemukan' }}
              </p>
            </section>

            <!-- Tombol pindah -->
            <div v-if="isAdmin" class="mp-move">
              <v-btn small depressed color="primary" :disabled="!pickedAvailable" @click="moveToSelected">
                Tambahkan<v-icon right small>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn small outlined color="primary" :disabled="displayAvailable.length === 0" @click="moveAllToSelected">
                Tambahkan semua<v-icon right small>mdi-chevron-double-right</v-icon>
              </v-btn>
              <v-btn small depressed color="error" :disabled="!pickedSelected" @click="moveToAvailable">
                <v-icon left small>mdi-chevron-left</v-icon>Keluarkan
              </v-btn>
              <v-btn small outlined color="error" :disabled="displaySelected.length === 0" @click="moveAllToAvailable">
                <v-icon left small>mdi-chevron-double-left</v-icon>Keluarkan semua
              </v-btn>
              <v-btn small text :disabled="tempArray.length === 0" @click="clearAll">Batalkan pilihan</v-btn>
            </div>

            <!-- Menu yang bisa diakses -->
            <section class="mp-panel mp-panel--granted">
              <header class="mp-panel__head">
                <h3 class="mp-panel__title">Bisa diakses <span class="mp-count">{{ displaySelected.length }}</span></h3>
                <v-text-field
                  v-model="searchSelected"
                  placeholder="Cari menu"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  outlined
                  clearable
                  hide-details
                  class="mp-search"
                />
              </header>
              <ul class="mp-list">
                <li v-for="item in filteredSelected" :key="'s-' + item.id">
                  <component
                    :is="isAdmin ? 'button' : 'div'"
                    :type="isAdmin ? 'button' : null"
                    class="mp-row"
                    :class="{ 'is-picked': isPicked(item) }"
                    :aria-pressed="isAdmin ? String(isPicked(item)) : null"
                    @click="isAdmin && toggleItem(item)"
                  >
                    <v-icon v-if="isAdmin" small class="mp-row__check">{{ isPicked(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                    <span class="mp-row__text">
                      <span class="mp-row__name">{{ item.nama }}</span>
                      <span v-if="hasRoute(item)" class="mp-row__route">{{ item.route }}</span>
                    </span>
                  </component>
                </li>
              </ul>
              <p v-if="filteredSelected.length === 0" class="mp-empty">
                {{ displaySelected.length === 0 ? 'Belum ada menu yang bisa diakses peran ini' : 'Menu tidak ditemukan' }}
              </p>
            </section>
          </div>

          <esign-confirm-dialog
            v-model="dialog"
            tone="primary"
            title="Simpan perubahan akses menu?"
            confirm-text="Simpan"
            @confirm="postData()"
          >
            Peran <b>{{ formData.nama }}</b> akan bisa mengakses {{ displaySelected.length }} menu.
          </esign-confirm-dialog>
        </material-card>
      </div>
    </v-container>
  </template>
<script>
  import { apiServer } from "../../setup-axios";

  export default {
    data: () => ({
      toggled: false,
      isLoading: false,
      dialog: false,
      selectedMenus: [],
      displaySelected: [],
      checkboxValue: false,
      availableMenus: [],
      displayAvailable: [],
      tempArray: [],
      leftTitle: "Menu yang dapat diakses Peran",
      rightTitle: "Menu yang tersedia",
      contentKey: "id",
      contentAttr: "nama",
      formData: {
        id: null,
        nama: null,
        kode_peran: null,
      },
      excluded: [],
      errorMessage: "",
      errorMessageData: false,
      currentPeran: "",
      searchAvailable: "",
      searchSelected: "",
    }),
    computed: {
      isAdmin() {
        return this.currentPeran === 'A01'
      },
      filteredAvailable() {
        return this.filterMenus(this.displayAvailable, this.searchAvailable)
      },
      filteredSelected() {
        return this.filterMenus(this.displaySelected, this.searchSelected)
      },
      pickedAvailable() {
        return this.tempArray.some(t => this.displayAvailable.some(m => m.id === t.id))
      },
      pickedSelected() {
        return this.tempArray.some(t => this.displaySelected.some(m => m.id === t.id))
      },
    },
    created() {
      console.log("loading")
      this.getData();
      this.currentPeran = localStorage.getItem('currentPeran')
    },
    methods: {
      getData() {
        console.log("get data peran" + this.$route.params.id)
        apiServer
          .get("/peran/" + this.$route.params.id)
          .then(response => {
            console.log("Got peran details")
            console.log(response.data.data)
            this.formData = response.data.data
            console.log("Got peran details")
            console.log(this.formData)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
        apiServer
          .get("/menu/peran/" + this.$route.params.id)
          .then(response => {
            console.log("Got peran")
            console.log(response.data.data)
            this.selectedMenus = JSON.parse(JSON.stringify(response.data.data))
            for(let i of this.selectedMenus){
              console.log(i)
              if (i.nama == 'HOME' || i.nama == 'LOGIN_HOME' || i.nama == 'LOGOUT' || i.nama == '404' || i.nama == '403') {
                
                this.excluded.push(i)
              }
            }
            this.displaySelected = this.selectedMenus.filter(menu => menu.nama !== "HOME" && menu.nama !== "LOGOUT" && menu.nama !== "LOGIN_HOME" && menu.nama !== "404" && menu.nama !== "403");
            console.log("Got peran")
            console.log("isi display: " + this.displaySelected)
            console.log("isi selected: " + this.selectedMenus)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
        console.log("get data not in peran" + this.$route.params.id)
        apiServer
          .get("/menu/exclperan/" + this.$route.params.id)
          .then(response => {
            console.log("Got exclperan")
            console.log(response.data.data)
            this.availableMenus = JSON.parse(JSON.stringify(response.data.data))
            this.displayAvailable = this.availableMenus.filter(menu => menu.nama !== "HOME" && menu.nama !== "LOGOUT" && menu.nama !== "LOGIN_HOME" && menu.nama !== "404" && menu.nama !== "403");
            console.log("Got exclperan")
            console.log(this.availableMenus)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
          });
      },
      postData() {
        console.log("save data")
        let saveData = new FormData()
        saveData.append("IdPeran", this.$route.params.id)
        for(let i of this.excluded){
          this.displaySelected.push(i)      
        }
        saveData.append("Menu", JSON.stringify(this.displaySelected))
        console.log(saveData.get("Menu"))
        apiServer
          .post("/menu/save-menu-peran", saveData)
          .then(response => {
            console.log("Successfully saved menu peran data")
            console.log(response.data.data)
            localStorage.setItem('updateSuccess', "Daftar Menu yang dapat diakses Peran " + this.formData.nama + " berhasil diubah.")
            this.$router.push("/menu")})
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.errorMessage = error.response.data.message
            this.errorMessageData = true
          })
      },
      save() {
        this.dialog = true;
      },
      back() {
        this.$router.push('/menu')
      },
      close() {
        this.dialog = false;
      },
      moveToSelected() {
        this.tempArray.forEach((item) => {
          const exist = this.displaySelected.findIndex((menu) => menu.id === item.id) > -1 ? true : false;
          if (!exist) {
            this.displaySelected.push(item);
          }
          const index = this.displayAvailable.findIndex((menu) => menu.id === item.id);
          if (index > -1) {
            this.displayAvailable.splice(index, 1);
          }
        });
        this.clearAll()
        this.sortAll()
      },
      moveAllToSelected() {
        this.displayAvailable.forEach((item) => {
          this.displaySelected.push(item);
        });
        this.displayAvailable = [];
        this.clearAll()
        this.sortAll()
      },
      clearAll() {
        this.tempArray = [];
        this.clearColorSelected()
        this.sortAll()
      },
      moveToAvailable() {
        this.tempArray.forEach((item) => {
          const exist = this.displayAvailable.findIndex((menu) => menu.id === item.id) > -1 ? true : false;
          if (!exist) {
            this.displayAvailable.push(item);
          }
          const index = this.displaySelected.findIndex((menu) => menu.id === item.id);
          if (index > -1) {
            this.displaySelected.splice(index, 1);
          }
        });
        this.clearAll()
        this.sortAll()
      },
      moveAllToAvailable() {
        this.displaySelected.forEach((item) => {
          this.displayAvailable.push(item);
        });
        this.displaySelected = [];
        this.clearAll()
        this.sortAll()
      },
      clearColorSelected() {
        this.displaySelected.forEach((item) => {
          const element = document.getElementById(item.id);
          if (element) {
            element.style.backgroundColor = '';
          }
        });
        this.displayAvailable.forEach((item) => {
          const element = document.getElementById(item.id);
          if (element) {
            element.style.backgroundColor = '';
          }
        });
      },
      toggleItem(item) {
        console.log("item clicked");
        // const index = this.tempArray.findIndex(element => element.id === item.id);
        const index = this.tempArray.findIndex(selectedItem => selectedItem.id === item.id);

        // If the item is found, remove it; otherwise, add it
        if (index > -1) {
          this.tempArray.splice(index, 1); // Use splice to remove item
        } else {
          this.tempArray.push(item);
        }
        
        const element = document.getElementById(item.id);
        if (element) {
          element.style.backgroundColor = index > -1 ? '' : 'lightblue';
        }
      }, 
      isPicked(item) {
        return this.tempArray.some(t => t.id === item.id)
      },
      hasRoute(item) {
        return item.route !== null && item.route !== 'none' && item.route !== ''
      },
      filterMenus(menus, query) {
        const q = (query || '').trim().toLowerCase()
        if (!q) return menus
        return menus.filter(m => (m.nama || '').toLowerCase().includes(q) || (m.route || '').toLowerCase().includes(q))
      },
      sortAll() {
        this.displaySelected.sort((a, b) => a.id - b.id);
        this.displayAvailable.sort((a, b) => a.id - b.id);
      }
    }
  }
</script>
  

<style scoped>
/* style.css forces h3 / p sizes with !important, so text rules here do too */
.mp-help {
  margin: 0 0 12px !important;
  font-size: 13px !important;
  line-height: 19px !important;
  color: var(--esign-text-muted);
}

.mp {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 16px;
  align-items: start;
}

.mp--readonly {
  grid-template-columns: 1fr 1fr;
}

.mp-panel {
  min-width: 0;
  border: 1px solid var(--esign-border);
  border-radius: var(--esign-radius-md);
  overflow: hidden;
}

.mp-panel__head {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-bottom: 1px solid var(--esign-border);
  background: var(--esign-surface-muted);
}

.mp-panel--granted .mp-panel__head {
  background: var(--esign-primary-soft);
}

.mp-panel__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  color: var(--esign-text);
}

.mp-count {
  padding: 0 8px;
  border-radius: 999px;
  background: var(--esign-surface);
  border: 1px solid var(--esign-border);
  font-size: 12px;
  font-weight: 600;
  color: var(--esign-text-muted);
}

.mp-search {
  background: var(--esign-surface);
}

.mp-list {
  max-height: 460px;
  margin: 0;
  padding: 6px;
  overflow-y: auto;
  list-style: none;
}

.mp-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border-radius: var(--esign-radius-sm);
  text-align: left;
}

button.mp-row:hover {
  background: var(--esign-surface-muted);
}

button.mp-row:focus-visible {
  outline: 2px solid var(--esign-primary);
  outline-offset: -2px;
}

.mp-row.is-picked {
  background: var(--esign-primary-subtle);
}

.mp-row__check.v-icon {
  margin-top: 2px;
  color: var(--esign-border-strong);
}

.mp-row.is-picked .mp-row__check.v-icon {
  color: var(--esign-primary);
}

.mp-row__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mp-row__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--esign-text);
  overflow-wrap: anywhere;
}

.mp-row__route {
  font-size: 12px;
  color: var(--esign-text-muted);
  overflow-wrap: anywhere;
}

.mp-empty {
  margin: 0 !important;
  padding: 20px 12px;
  font-size: 13px !important;
  color: var(--esign-text-subtle);
  text-align: center;
}

.mp-move {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 64px;
}

.mp-move .v-btn {
  justify-content: space-between;
}

@media (max-width: 960px) {
  .mp,
  .mp--readonly {
    grid-template-columns: 1fr;
  }

  .mp-move {
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 0;
  }

  .mp-move .v-btn {
    flex: 1 1 140px;
  }
}
</style>
